import React, { useEffect, useMemo, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Enlaces from '../../components/asignaturas/contenido/Enlaces';
import Introduccion from '../../components/asignaturas/contenido/Introduccion';
import MenuThemes from '../../components/asignaturas/contenido/MenuThemes';
import Preguntas from '../../components/asignaturas/contenido/Preguntas';
import SeccionDos from '../../components/asignaturas/contenido/SeccionDos';
import SeccionTres from '../../components/asignaturas/contenido/SeccionTres';
import SeccionUno from '../../components/asignaturas/contenido/SeccionUno';
import Layout from '../../components/layout/Layout'
import LoadingComponent from '../../components/tools/LoadingComponent';
import LoadingContenido from '../../components/tools/LoadingContenido';
import { getAsignaturaId } from '../../helpers/asignaturas';
import { handleLoadContenido } from '../../helpers/contenido';

const AsignaturasThemesView = () => {
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.perfil);
    const { idAsig,idTema } = useParams();
    const [dataAsig, setDataAsig] = useState();
    const { asignaturas } = useSelector(state => state.asignaturas);
    const asignatura = useMemo(() => getAsignaturaId(idAsig,asignaturas), [idAsig, asignaturas])
    const {introduccion, seccion1, seccion2, seccion3, enlaces, preguntas} = useSelector(state => state.contenido)
    const [topicChange, setTopicChange] = useState(false)
    useEffect(() => {
        asignatura.then(data => {
            setDataAsig(data)
        });
        dispatch(handleLoadContenido(email,idAsig,idTema))
        return () => {}
    }, [email,idAsig,idTema, dispatch , asignatura])


    useEffect(() => {
        setTopicChange(true)
        setTimeout(() => {
            setTopicChange(false)
        }, 2000);
        return () => { 
            setTopicChange(false)
         }
    }, [idTema])

    return (
        <Layout>
            {
                introduccion.length === 0 ||
                seccion1.length === 0 ||
                seccion2.length === 0 ||
                seccion3.length === 0 ||
                enlaces.length === 0
                ?<LoadingComponent />
                :
                    <>
                        <h1 className='txt_title'>Curso {dataAsig?.nameSubject}</h1>
                            <MenuThemes idAsig={idAsig}  />
                        <div className='container_contenido'>
                            {
                                topicChange
                                ? <LoadingContenido />
                                :
                                <>
                                    <Introduccion data={introduccion} 
                                        email={email} idAsig={idAsig} idTema={idTema} 
                                    />
                                    <SeccionUno data={seccion1} email={email} idAsig={idAsig} idTema={idTema} />
                                    <SeccionDos data={seccion2} email={email} idAsig={idAsig} idTema={idTema} />
                                    <SeccionTres data={seccion3} email={email} idAsig={idAsig} idTema={idTema} />
                                    <Enlaces data={enlaces} email={email} idAsig={idAsig} idTema={idTema} />
                                    <Preguntas data={preguntas} email={email} idAsig={idAsig} idTema={idTema} />
                                </>
                            }
                            
                        </div>
                    </>
            }            
        </Layout>
    )
}

export default AsignaturasThemesView